// pinia plugin that will persist values in local storage
import { Api } from "@switchsystems/coactive-vue-lib";

export function setItem(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function getItem(key, options) {
  const valueStr = localStorage.getItem(key);
  if (valueStr != null) {
    if (options.localStorage.parseDates) {
      return Api.transformResponse(valueStr);
    } else {
      return JSON.parse(valueStr);
    }
  }
  return null;
}

function removeItem(key) {
  localStorage.removeItem(key);
}

export default function localStoragePlugin({ options, store }) {
  if (options.localStorage != null) {
    const key = store.$id;

    const state = getItem(key, options);
    if (state != null) {
      if (options.localStorage.fromStorage) {
        store.$patch(options.localStorage.fromStorage(state));
      } else {
        store.$state = state;
      }
    }

    store.$subscribe(async (mutation, state) => {
      let saveState = state;
      if (options.localStorage.toStorage) {
        saveState = options.localStorage.toStorage(state);
      }
      setItem(key, saveState);
    });

    // override the $reset function
    const originalReset = store.$reset.bind(store);
    return {
      $reset() {
        originalReset();
        removeItem(key);
      },
    };
  }
}
